import { Row, Button, Col, Input } from "antd";
import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AppModal from "../../components/AppModal/AppModal";
import {
  FORM_FIELDS_LOOKUP,
  FORM_FIELDS_TYPE,
  HELPER_TEXT_KEYS,
  LAND_REQUIRED_FIELDS_LOOKUP,
  LAND_TABS_KEYS,
  LANGUAGE_CODES,
} from "../../utils/constants";
import { validateMarketingDescription } from "../../utils/utils";
import CustomFormItem from "../../components/CustomFormItem/CustomFormItem";
import LabelWithDropDown from "../../components/LabelWithDropDown/LabelWithDropDown";

import { useLanguage } from "../../hooks";
const MarketingDescription = ({ viewOnlyMode, form, templateList, auditPanelDrawerVisible }) => {
  const { lookupList } = useSelector(state => state.helperText);
  const { t } = useTranslation();
  const { language, languageStatus } = useLanguage();
  const [modalVisible, setModalVisibility] = useState(false);
  const fieldsType = FORM_FIELDS_TYPE.regular;

  const [templateId, setTemplateId] = useState(null);
  const setTemplateDescription = data => {
    if (!_isEmpty(data)) {
      if (_isEmpty(form.getFieldValue("descriptionTab")?.marketingDescription)) {
        populateDescription(data);
      } else {
        setModalVisibility(true);
      }
    }
  };

  const populateDescription = data => {
    if (data) {
      const selectedTemplate = templateList.find(item => item.id === data);
      const country = form.getFieldValue(["landInfo", "address", "country"]);
      const marketingDescription = _get(
        selectedTemplate,
        `translations.${
          country === "Mexico" && language.current !== LANGUAGE_CODES.English.value
            ? LANGUAGE_CODES.Mexico.value
            : language.current
        }.template`,
        selectedTemplate?.template,
      );
      const obj = {};
      if (languageStatus !== "primary") {
        obj.translations = {
          [language.current]: { descriptionTab: { marketingDescription } },
        };
      } else {
        obj.descriptionTab = { marketingDescription };
      }
      form.setFieldsValue({ ...obj });
      setTemplateId(data);
    }
  };

  const _onCancel = () => {
    setModalVisibility(false);
    form.setFieldsValue({ landInfo: { templateId } });
    console.log("form", form);
    console.log("clicking cancel", templateId);
  };

  const _onConfirm = () => {
    populateDescription(form.getFieldValue(["landInfo", "templateId"]));
    setModalVisibility(false);
  };

  return (
    <>
      <Col span={8} xs={24} sm={8} lg={8}>
        <CustomFormItem
          className="form-item-label-with-drop-down"
          label={
            <LabelWithDropDown
              label={t("Property.MarketingDescription")}
              tooltip={lookupList[HELPER_TEXT_KEYS.land.marketingDescription]}
              templateId={templateId}
              changeHandler={setTemplateDescription}
              options={templateList}
              viewOnlyMode={viewOnlyMode}
              name={["landInfo", "templateId"]}
              form={form}
              tab={LAND_TABS_KEYS[6]}
              fieldName={FORM_FIELDS_LOOKUP.land.landInfo.marketingDescription.key}
              auditPanelDrawerVisible={auditPanelDrawerVisible}
            />
          }
          name={["descriptionTab", "marketingDescription"]}
          rules={[
            {
              required: LAND_REQUIRED_FIELDS_LOOKUP[fieldsType].descriptionTab.marketingDescription,
              message: t("LandInfo.MarketingDescriptionRulesMessage"),
            },
            { whitespace: true, message: t("LandInfo.MarketingDescriptionWhitespaceMessage") },
            {
              validator: (rule, value) => validateMarketingDescription(value, t("Property.MarketingDescription")),
            },
          ]}
        >
          <Input.TextArea placeholder={t("Property.MarketingDescription")} row={5} disabled={viewOnlyMode} />
        </CustomFormItem>
      </Col>
      <AppModal
        centered
        wrapClassName="modal-associated-properties"
        title={t("Template.Confirmation")}
        width={600}
        minHeight="10vh"
        maxHeight="60vh"
        overFlowY="auto"
        visible={modalVisible}
        onCancel={_onCancel}
        footer={
          <Row justify="center" gutter={24}>
            <Col xs={12} sm={12} md={8} lg={8}>
              <Button block onClick={_onCancel}>
                {t("Buttons.Cancel")}
              </Button>
            </Col>
            <Col xs={12} sm={12} md={8} lg={8}>
              <Button block type="primary" onClick={_onConfirm}>
                {t("Buttons.Confirm")}
              </Button>
            </Col>
          </Row>
        }
        destroyOnClose
      >
        <p>{t("Template.ConfirmationMessage")}</p>
      </AppModal>
    </>
  );
};

MarketingDescription.propTypes = {
  viewOnlyMode: PropTypes.bool,
  form: PropTypes.object,
  templateList: PropTypes.array,
  auditPanelDrawerVisible: PropTypes.bool,
};
export default MarketingDescription;
